import React from "react";
import { Layout } from "antd";
import styles from "./Footer.module.scss";

const { Footer: AntFooter } = Layout;

const AppFooter: React.FC = () => {
  return (
    <AntFooter className={styles.footer}>
      <div className={styles.footerContent}>
        <span>VetanaHR © {new Date().getFullYear()}</span>
        <span className={styles.divider}>|</span>
        <span>Powered by Vetana Software Solutions LLP</span>
      </div>
    </AntFooter>
  );
};

export default AppFooter;
